import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserOnboarding } from '../models/user-onboarding.model';
import { Appointment } from '../models/appointment.model';
import { DoctorOnboarding } from '../models/doctor-onboarding.model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  private apiUrl = environment.APP_BASE_URL + '/doctor-portal/registration-view/registration';

  constructor(private http: HttpClient) {}

  registerUser(user: UserOnboarding): Observable<string> {
    return this.http.post(`${this.apiUrl}/create-user`, user, { responseType: 'text' });
  }

  registerDoctor(doctor: DoctorOnboarding) {
    return this.http.post<DoctorOnboarding>(`${this.apiUrl}/create-doctor`, doctor);
  }

  verify(data: any) {
    return this.http.post<DoctorOnboarding>(`${this.apiUrl}/document`, data);
  }

  verifyOtp(otp: string, userId: string | null): Observable<any> {
    return this.http.post(`${this.apiUrl}/verify/user/${userId}/otp/${otp}`, {});
  }

  resendOtp(): Observable<any> {
    return this.http.post(`${this.apiUrl}/resend-otp`, {});
  }
}
